/* eslint-disable no-unused-vars */
import debugFactory from "debug";
import { clientIdentifier as thisClientId, listenTo } from "@teaming/io-helpers";
import { SocketMessageType } from "@teaming/common-enums";

export function configureSockets( { storeName, store, ioSocket, ioTeam, ioGokr, } ) {
	const debug = debugFactory( `teaming:common-gokr:stores:${ storeName }:sockets` );

	const commit = ( mutationName, args ) => store.commit( `${ storeName }/${ mutationName }`, args );

	[
		SocketMessageType.GOAL_DELETED,
	].forEach( socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			const { body, clientIdentifier: messageClientId, } = message;
			debug( "received socket message", message, { thisClientId, messageClientId, } );
			const { goalId, } = body;
			commit( "receiveDeletedGoal", goalId );
			if ( messageClientId === thisClientId ) {
				commit( "selectTeam", "" );
			}
		} );
	} );

	[
		SocketMessageType.GOAL_CREATED,
		SocketMessageType.GOAL_UPDATED,
		SocketMessageType.KEYRESULT_CREATED,
		SocketMessageType.KEYRESULT_UPDATED,
	].forEach( socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			const { body, clientIdentifier: messageClientId, } = message;
			debug( "received socket message", message, { thisClientId, messageClientId, } );
			if ( messageClientId === thisClientId ) {
				return;
			}
			const { goalId, } = body;
			const { data: goal, } = await ioGokr.fetchGoal( { goalId, }, { refetch: true, } );
			commit( "receiveGoal", goal );
			if ( goal.archived ) {
				commit( "receiveArchivedGoal", goalId );
			}
		} );
	} );
}

export function configureChannels( { storeName, store, ioChannel, } ) {
	const debug = debugFactory( `teaming:common-gokr:stores:${ storeName }:channels` );

	const commit = ( mutationName, args ) => store.commit( `${ storeName }/${ mutationName }`, args );

	listenTo( ioChannel, "gokr.archiveGoal", {
		success: ( { args, } ) => {
			const { goalId, } = args[ 0 ];
			commit( "receiveArchivedGoal", goalId );
		},
	} );
}
